import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import {
  validationSchema,
  initialValues as emptyValues,
} from "./formCraneConfig.js";

import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Swal from "sweetalert2";
import Select from "react-select";
import axiosClient from "../../../../config/axios.js";
import FormCrane from "./formCrane.js";
import Loader from "../../../../components/loader/index.js";
// import {
//   findPermissionTypesByCoincidence,
//   findAutotransportConfigByCoincidence,
// } from "../../../../services/CartaPorteService.js";

function EditCrane() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [craneTypes, setCraneTypes] = useState([]);
  const [insurers, setInsurers] = useState([]);
  const [initialValues, setInitialValues] = useState(emptyValues);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);

        // Obtener grúa
        const resCrane = await axiosClient.get(`/cranes/${id}`);
        const data = resCrane.data;

        // Obtener objetos completos usando el id
        // const sctPermitObj = await findPermissionTypesByCoincidence(
        //   data.sct_permit
        // );
        // const vehicularConfigObj = await findAutotransportConfigByCoincidence(
        //   data.vehicular_config
        // );

        const mappedValues = {
          crane_number: data.crane_number || "",
          description: data.description || "",
          year: data.year || "",
          plate: data.plate || "",
          capacity: data.capacity || "",
          serial_number: data.serial_number || "",
        //   vehicular_config: vehicularConfigObj?.[0] || null,
          vehicular_config_description: data.vehicular_config_description || "",
          gross_vehicle_weight: data.gross_vehicle_weight || "",
          civil_liability_policy: data.civil_liability_policy || "",
          insurance_id: data.insurance_id || "",
          crane_type_id:
            data.CraneTypes?.map((item) => ({
              value: item.CraneCraneType.CraneTypeId,
              label: item.crane_type_name,
            })) || [],
        //   sct_permit: sctPermitObj?.[0] || null,
          sct_permit_number: data.sct_permit_number || "",
        };
        //console.log(mappedValues);

        setInitialValues(mappedValues);

        // Obtener tipos de grúa
        const resCraneTypes = await axiosClient.get(`/craneTypes/datatable`, {
          params: {
            start: 0,
            length: 100,
            search: "",
            sort: "crane_type_name",
            dir: "asc",
          },
        });
        const craneTypesOptions = resCraneTypes.data.data.map((item) => ({
          value: item.id,
          label: item.crane_type_name,
        }));
        setCraneTypes(craneTypesOptions);

        // Obtener aseguradoras
        const resInsurers = await axiosClient.get(`/insurers/all`);
        const insurersOptions = resInsurers.data.data.map((item) => ({
          value: item.id,
          label: item.insurance_name,
        }));
        setInsurers(insurersOptions);
      } catch (error) {
        Swal.fire("Error", "No se pudo cargar la grúa", "error");
        navigate("/catalogs/cranes");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [id, navigate]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      const payload = {
        crane_number: values.crane_number.trim(),
        plate: values.plate.trim(),
        description: values.description.trim(),
        year: Number(values.year),
        capacity: Number(values.capacity),
        serial_number: values.serial_number.trim(),
        vehicular_config: values.vehicular_config?.id || null,
        vehicular_config_description:
          values.vehicular_config?.descripcion || null,
        gross_vehicle_weight: values.gross_vehicle_weight || null,
        civil_liability_policy: values.civil_liability_policy || null,
        insurance_id: values.insurance_id ? Number(values.insurance_id) : null,
        crane_type_ids: values.crane_type_id.map((item) => item.value),
        sct_permit: values.sct_permit?.id || null,
        sct_permit_number: values.sct_permit_number.trim(),
      };

      axiosClient
        .put(`/cranes/${id}`, payload)
        .then(() => {
          Swal.fire(
            "Actualización exitosa",
            "La grúa fue actualizada.",
            "success"
          );
          //navigate("/catalogs/cranes");
        })
        .catch((err) => {
          const msg = err.response?.data?.message || "Error al actualizar";
          Swal.fire("Error", msg, "error");
        })
        .finally(() => setSubmitting(false));
    },
  });

  if (loading) return <Loader isLoading={true} />;

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item">
              <Link to="/catalogs/cranes">Grúas</Link>
            </li>
            <li className="breadcrumb-item active">Editar Grúa</li>
          </ol>
          <h1 className="page-header mb-0">Editar Grúa</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Editar Grúa</PanelHeader>
            <PanelBody>
              <Form noValidate onSubmit={formik.handleSubmit}>
                <FormCrane
                  formik={formik}
                  craneTypes={craneTypes}
                  insurers={insurers}
                //   findPermissionTypesByCoincidence={
                //     findPermissionTypesByCoincidence
                //   }
                //   findAutotransportConfigByCoincidence={
                //     findAutotransportConfigByCoincidence
                //   }
                />

                <Row className="mb-3">
                  <Col md="12">
                    <Button type="submit" disabled={formik.isSubmitting}>
                      Actualizar Grúa
                    </Button>{" "}
                    <Link to="/catalogs/cranes" className="btn btn-info">
                      Cancelar
                    </Link>
                  </Col>
                </Row>
              </Form>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default EditCrane;